import type { JointAxesSlice, JointAxesState, ViewerSliceCreator } from "./types";

export const jointAxesInitialState: JointAxesState = {
  jointAxesMode: false,
  jointAxes: [],
  jointAxesLabelMode: "key",
  jointAxesShowFrames: false,
  jointAxesSizePx: 46,
  jointAxesHoveredName: null,
  jointAxesMirrorAxis: "y",
};

export const createJointAxesSlice: ViewerSliceCreator<JointAxesSlice> = (set) => ({
  ...jointAxesInitialState,

  setJointAxesMode: (enabled) =>
    set((state) => {
      state.jointAxesMode = enabled;
      state.jointAxesHoveredName = null;
      if (!enabled) {
        // Otherwise the axes of a robot that has since been rebuilt would
        // flash up at their old places the moment the mode is switched
        // back on, before the server's answer arrives.
        state.jointAxes = [];
      }
    }),

  setJointAxes: (msg) =>
    set((state) => {
      state.jointAxesMode = msg.enabled;
      state.jointAxes = msg.enabled ? msg.axes : [];
    }),

  setJointAxesLabelMode: (mode) =>
    set((state) => {
      state.jointAxesLabelMode = mode;
    }),

  setJointAxesShowFrames: (show) =>
    set((state) => {
      state.jointAxesShowFrames = show;
    }),

  setJointAxesSizePx: (sizePx) =>
    set((state) => {
      state.jointAxesSizePx = sizePx;
    }),

  setJointAxesHoveredName: (name) =>
    set((state) => {
      state.jointAxesHoveredName = name;
    }),

  setJointAxesMirrorAxis: (axis) =>
    set((state) => {
      state.jointAxesMirrorAxis = axis;
    }),
});
